import { apiRequest } from "../util/apiUtils";

export const collectionList = async (params) => {
  try {
    const res = await apiRequest("get", `collection/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const collectionDetails = async (params) => {
  try {
    const res = await apiRequest("get", `collection/detail/${params?.id}`, {});

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const collectionAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `collection/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const collectionDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `collection/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const collectionStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `collection/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
